<script lang="ts">
    import Image from './Image.svelte';
    import clsx from 'clsx';

    export let mode: 'dark' | 'light';
    export let headline = '';
    export let subHeadline = '';
    export let image: string;
    export let fixedMaxWidth: number;
    export let isInMultiColumn = false;
</script>

<div
    class={clsx('relative w-full', {
        'bg-black': mode === 'dark',
        'bg-white': mode === 'light',
    })}
>
    <div
        style="transform: translate3d(0,0,3px)"
        class:text-white={mode === 'dark'}
        class:text-black={mode === 'light'}
        class={clsx(
            'absolute inset-x-0 bottom-8 z-20 flex w-full flex-col items-center px-7 text-center',
            {
                'md:top-0 md:w-[60%] md:items-start md:justify-center md:text-left':
                    !isInMultiColumn,
            },
        )}
    >
        <p
            class={clsx('mb-5 text-lg font-semibold', {
                'md:text-2xl': !isInMultiColumn,
                'lg:text-4xl': headline.length <= 150 && !isInMultiColumn,
                'lg:text-2xl': headline.length > 150 && !isInMultiColumn,
            })}
        >
            {headline}
        </p>
        <p class={clsx('text-sm font-semibold', { 'md:text-lg': !isInMultiColumn })}>
            {subHeadline}
        </p>
    </div>
    <div
        style="transform: translate3d(0,0,2px)"
        class={clsx('absolute inset-0 z-10 h-full w-full', {
            'bg-gradient-to-t from-black to-black/0': mode === 'dark',
            'bg-gradient-to-t from-white to-white/0': mode === 'light',
            'md:hidden': !isInMultiColumn,
        })}
    />
    <div class={clsx('relative ml-auto', { 'md:max-w-md': !isInMultiColumn })}>
        <div
            style="transform: translate3d(0,0,2px)"
            class={clsx(
                'absolute -left-1 bottom-0 top-0 z-10 hidden h-full w-[60%] bg-gradient-to-r',
                {
                    'from-black to-black/0': mode === 'dark',
                    'from-white to-white/0': mode === 'light',
                    'md:block': !isInMultiColumn,
                },
            )}
        />
        <div style="transform: translate3d(0,0,1px)">
            <Image size="xLarge" src={image} {fixedMaxWidth} />
        </div>
    </div>
</div>
